export default __webpack_public_path__ + "static/media/header-visuel-2.b4545133.webp";